<template>
  <datepicker class="form-control"
              v-model="date" :inputFormat="dateFormat"
              :locale="locale"
              :style="{background: !disabled ? '#fff' : null}"
              :clearable="clearable"
              :disabled="disabled"
              :required="required"/>
  <div class="invalid-msg" v-if="v$.date.$error">
    <template v-if="v$.date.required.$invalid">Поле обязательно для заполнения</template>
  </div>
</template>
<script>
import datepicker from 'vue3-datepicker'
import {ru} from 'date-fns/locale'
import moment from 'moment'
import {requiredIf} from "@vuelidate/validators";
import {useVuelidate} from '@vuelidate/core'

export default {
  components: {
    datepicker
  },
  props: {
    modelValue: String,
    clearable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: null,
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  created() {
    if (this.modelValue)
      this.date = this.modelValue ? new Date(Date.parse(this.modelValue)) : null;
  },
  data() {
    return {
      dateFormat: 'dd.MM.yyyy',
      date: null,
      locale: ru
    }
  },
  watch: {
    modelValue: function (newValue) {
      this.date = newValue ? new Date(Date.parse(newValue)) : null;
    },
    date: function (newValue) {
      this.$emit('update:modelValue', newValue != null ? moment(newValue).format("YYYY-MM-DD") : null);
    }
  },
  setup: () => ({v$: useVuelidate()}),
  validations() {
    return {
      date: {
        required: requiredIf(function () {
          return this.required
        }),
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "src/assets/theme/default/colors";

.invalid-msg {
  color: red;
  font-size: 0.75rem;
}


.v3dp__input_wrapper {
  position: relative;

  input, input[readonly] {
    width: 100%;
    display: inline-block;
    background-color: #fff !important;
  }
}
</style>